<template>
  <span>
    <v-dialog v-model="mostrar" hide-overlay persistent width="500">
      <v-card>
        <v-system-bar color="headeryfooter darken-2" dark>
          <v-spacer></v-spacer>
          <v-icon @click="mostrar = false">mdi-close</v-icon>
        </v-system-bar>
        <v-container>
          <v-data-table
            mobile-breakpoint="0"
            dense
            light
            fixed-header
            :headers="headers"
            :items="vigentes"
            item-key="id"
          ></v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card v-if="vigentes.length > 0">
      <v-card-text>
        <v-row align="center">
          <v-checkbox
            :disabled="readonly"
            dense
            hide-details
            v-model="desestimo"
            class="shrink mr-2 mt-0"
          >
            <template v-slot:label>
              <h4>Desestimar Patologias</h4>
            </template>
          </v-checkbox>
          <v-btn icon @click="mostrar = true">
            <v-badge inline color="green" :content="vigentes.length"></v-badge>
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </span>
</template>

<script>
import { mapState } from "vuex";
import LUM from "@/lib/LUM";
export default {
  props: {
    patologias: { type: Array },
    value: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrar: false,
      desestimo: false,
      headers: [
        {
          text: "Patologia",
          value: "patologia.descripcion_patologia",
        },
        {
          text: "Desde",
          value: "fechadesde",
        },
      ],
    };
  },
  computed: {
    ...mapState("patologias", ["Lista"]),
    vigentes() {
      let ret = [];
      if (this.patologias) {
        let vig = this.patologias.filter(
          (x) =>
            !x.fechahasta || x.fechahasta > this.arreglarlaFecha(new Date())
        );
        ret = vig.map((x) => {
          return {
            ...x,
            desde: this.arreglarFecha(x.fechadesde),
            patologia: this.Lista.find((y) => y.id_patologia == x.id_patologia),
          };
        });
      }
      return ret;
    },
  },
  methods: {
    arreglarFecha(fecha) {
      return LUM.dataStringToDDMMYYYY(fecha);
    },
    arreglarlaFecha(fecha) {
      return LUM.datetoDDMMYYYYHHMMSS(fecha);
    },
  },
  watch: {
    value() {
      this.desestimo = this.value;
    },
    desestimo() {
      this.$emit("input", this.desestimo);
    },
  },
};
</script>

<style></style>
